export default [
  { title: 'Planning', route: 'planning', icon: 'CalendarIcon' },
  { title: 'Jeunes', route: 'youngs', icon: 'UsersIcon' },
  { title: 'Demandes d\'hébergement', route: 'accommodation-requests', icon: 'HomeIcon' },
  { title: 'Statistiques', route: 'statistics', icon: 'BarChart2Icon' },
]
